import {Box, Tab, Tabs} from "@mui/material";
import {useContext, useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useRecoilState} from "recoil";
import SectionHeader from "../../../../util/component/SectionHeader";
import {Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {FINE_TYPE_PARKING_FINES, FINE_TYPE_PENALTIES, STATE_ACTIVE_TAB} from "../../component/Constants";
import FinesList from "./FinesList";
import NotAuthorizedDialog from "../../../authentication/component/NotAuthorizedDialog";
import * as React from "react";
import {useHasScope} from "../../../../config/globalConfig";
import {SCOPE_FINES_MANAGEMENT, FINES_SCOPE_VIEW_CUSTOMER} from "../../component/utils/AuthConstants";
import {GlobalContext} from "../../../../util/state/GlobalContextProvider";

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    style?: React.CSSProperties;
}

function TabPanel(props: TabPanelProps) {
    const {children, value, index, ...other} = props;

    return (
        <div
            role="tabpanel"
            style={{display: value === index ? 'block' : 'none'}}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {children}
        </div>
    );
}

const Fines = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'fines'});
    const {t: tr} = useTranslation("translation");
    const hasScope = useHasScope;
    const {globalData} = useContext(GlobalContext);
    const [activeTab, setActiveTab] = useRecoilState(STATE_ACTIVE_TAB);
    const navigate = useNavigate();
    const location = useLocation();
    const rootFinesLocation = '/finessecurity/fines';
    const penaltiesLocation = '/finessecurity/fines/penalties';
    const finesAndPenaltiesLocation = '/finessecurity/fines/finesAndPenalties';

    const tenants: string[] =
        globalData.user.legalEntities
            .filter((elem: any) => elem.name !== 'all')
            .map((elem: any) => elem.name);
    const enableParking = tenants.includes('drivalia_fr');

    function a11yProps(index: number) {
        return {
            id: `simple-tab-${index}`, 'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const changeTabAndPath = (newValue: any) => {
        setActiveTab(newValue);
        // Preserve query parameters when changing tabs
        const searchParams = new URLSearchParams(location.search);
        const queryString = searchParams.toString();
        const targetPath = newValue ? finesAndPenaltiesLocation : penaltiesLocation;
        navigate(queryString ? `${targetPath}?${queryString}` : targetPath);
    }

    useEffect(() => {
        // Set active tab based on current path
        if (location.pathname === rootFinesLocation || location.pathname === penaltiesLocation) {
            setActiveTab(0);
            // If we're at root with query params, redirect to penalties with query params
            if (location.pathname === rootFinesLocation && location.search) {
                navigate(`${penaltiesLocation}${location.search}`, { replace: true });
            }
        } else if (location.pathname === finesAndPenaltiesLocation) {
            setActiveTab(1);
        }
    }, [location.pathname])

    return (
        (hasScope(SCOPE_FINES_MANAGEMENT) || hasScope(FINES_SCOPE_VIEW_CUSTOMER)) ?
            <Box>
                <SectionHeader title={t('listHeader.title')}
                               subtitle={t('listHeader.subTitle')}/>

                <Box sx={{borderBottom: 1, borderColor: 'divider'}}>
                    <Tabs value={activeTab} onChange={(_event, newValue: number) => changeTabAndPath(newValue)}>
                        <Tab label={t('tabs.penalties')} {...a11yProps(0)} />
                        {enableParking && <Tab label={t('tabs.finesAndPenalties')} {...a11yProps(1)} />}
                    </Tabs>
                </Box>
                <TabPanel value={activeTab} index={0} style={{display: activeTab === 0 ? 'block' : 'none'}}>
                    <FinesList key={FINE_TYPE_PENALTIES} finesType={FINE_TYPE_PENALTIES}/>
                </TabPanel>
                {enableParking &&
                    <TabPanel value={activeTab} index={1} style={{display: activeTab === 1 ? 'block' : 'none'}}>
                        <FinesList key={FINE_TYPE_PARKING_FINES} finesType={FINE_TYPE_PARKING_FINES}/>
                    </TabPanel>}
            </Box>
            : <NotAuthorizedDialog/>
    );
}

export default Fines;